import React from 'react';

const QuicklinkArrow = () => (
  <svg className={'quicklinks__arrow'} width={14.2} height={22} viewBox="0 0 14.2 22">
      <path fill="#fff" d="M14.2 11L3.2 0 0 3.1 7.9 11 0 18.9 3.2 22z" />
  </svg>
);

export default QuicklinkArrow;